// Nombre de un médico tal como se muestra en pantalla: "Dr. Carlos López".
//
// Se armaba a mano en cada vista con `Dr. {firstName} {lastName}`; cuando el
// usuario del médico no venía populado, unas vistas imprimían "Dr. undefined
// undefined" y otras "Dr. ". Aquí, si no hay nombre, se usa `fallback`.

/**
 * @param {object} doctor    documento Doctor con `user.profile` populado
 * @param {string} fallback  texto si el médico no tiene nombre conocido
 */
export const formatDoctorName = (doctor, fallback = 'Doctor') => {
  const { firstName = '', lastName = '' } = doctor?.user?.profile || {};
  const name = `${firstName} ${lastName}`.trim();
  return name ? `Dr. ${name}` : fallback;
};
